import _ from "lodash";
import { api } from "../Configurations/axios";
import { InvoicingFinep } from "../Models/InvoicingFinepModel";

const PostInvoicingFinep = async (invoicingFinep : InvoicingFinep) => {
    try {
        const result = await api.post('/InvoicingFinep/Post', invoicingFinep);
        const response = await result.data;

        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const PutInvoicingFinep = async (invoicingFinep : InvoicingFinep) => {
    try {
        const result = await api.put('/InvoicingFinep/Put', invoicingFinep);
        const response = await result.data;

        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

interface PutValidateInvoicingModel {
    registerId: string;
    isValid: boolean;
}

const PutValidateInvoicingFinep = async (invoicingFinep : PutValidateInvoicingModel) => {
    try {
        const result = await api.put('/InvoicingFinep/PutValidate', invoicingFinep);
        const response = await result.data;


        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetInvoicingsFinep = async (registerId : string) : Promise<InvoicingFinep[]> => {
    try {
        const result = await api.get(`/InvoicingFinep/GetByregistrationDocumentsId/${registerId}`);
        const response = await result.data;

        return response.data;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export {
    PutValidateInvoicingFinep,
    GetInvoicingsFinep,
    PostInvoicingFinep,
    PutInvoicingFinep
}